<div class="product-media-viewer-content" [ngClass]="{ 'is-grid-view': isGridView }">
	<div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center">
		<!-- @see https://github.com/angular/angular/issues/20845 -->
		<button
			fxFlex="38px"
			class="select-adjacent prev"
			*ngIf="isGridView"
			[disabled]="!canSelectAdjacent($any(-1))"
			(click)="selectAdjacent($any(-1))"
		>
			<g-icon [icon]="icons.faAngleLeft" />
		</button>
		<g-zoomable-image fxFlex [images]="items" [imageIndex]="shownItem" key="fitIn_2000x2000">
			<div class="square-image-container shown-item">
				<div class="square-image-inner product-image-wrapper">
					<img
						i18n-alt="@@AriaProductDetailMainImageAlt"
						alt="Product image"
						data-cy="productDetailMainImage"
						gFallbackProductImage
						[src]="items | getProductMediaUrl: { index: shownItem }"
						class="square-image-centered"
					/>
				</div>
			</div>
		</g-zoomable-image>
		<button
			fxFlex="38px"
			class="select-adjacent next"
			*ngIf="isGridView"
			[disabled]="!canSelectAdjacent(1)"
			(click)="selectAdjacent(1)"
		>
			<g-icon [icon]="icons.faAngleRight" />
		</button>
	</div>

	<div class="item-selector" fxLayout="row" fxLayoutGap="20px" *ngIf="items?.length > 1">
		<!-- @see https://github.com/angular/angular/issues/20845 -->
		<button
			class="select-adjacent prev"
			*ngIf="!isGridView"
			[disabled]="!canSelectAdjacent($any(-1))"
			(click)="selectAdjacent($any(-1))"
		>
			<g-icon [icon]="icons.faAngleLeft" />
		</button>
		<div class="grid-view-spacer" fxFlex="33px" *ngIf="isGridView"></div>
		<div class="item-selector-links" data-cy="productImageThumbnails">
			<div
				#selectableItem
				class="selectable-item"
				*ngFor="let item of items; let $index = index"
				[ngClass]="{ selected: $index === shownItem }"
			>
				<div class="square-image-container">
					<div class="square-image-inner">
						<a class="square-image-centered thumbnail-link" (click)="selectItem($index)">
							<img
								i18n-alt="@@AriaProductDetailThumbnailImageAlt"
								alt="Product thumbnail"
								class="product-image-thumbnail"
								gFallbackProductImage
								[src]="items | getProductMediaUrl: { index: $index, thumbnail: true }"
								loading="lazy"
							/>
						</a>
					</div>
				</div>
			</div>
		</div>
		<button
			class="select-adjacent next"
			*ngIf="!isGridView"
			[disabled]="!canSelectAdjacent(1)"
			(click)="selectAdjacent(1)"
		>
			<g-icon [icon]="icons.faAngleRight" />
		</button>
		<div class="grid-view-spacer" fxFlex="33px" *ngIf="isGridView"></div>
	</div>
</div>
